import { Controller } from 'stimulus'
import StimulusReflex from 'stimulus_reflex'

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  connect () {
    StimulusReflex.register(this)
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  beforeReflex (element, reflex, noop, reflexId) {
    if ( reflex.includes('#add_') ) {
      $('.summernote').each(function() {
        $(this).summernote('destroy')
      })
    }
  }

  reflexSuccess (element, reflex, noop, reflexId) {
    // show success message etc...
  }

  reflexError (element, reflex, error, reflexId) {
    // show error message etc...
  }

  afterReflex (element, reflex, noop, reflexId) {
    if ( reflex.includes('#add_') ) {
      initSummernote()
    }

    if ( reflex == 'ProjectsReflex#load_page' ) {
      addMasonryNewItems()
    }

  }
}

function addMasonryNewItems() {
  const newElementsDiv = document.querySelector('#to-add')
  const newElements = newElementsDiv.querySelectorAll('a')
  const productsGrid = document.querySelector('.projects-grid')

  let delay = 0
  let elementsLoaded = new Promise((resolve, reject) => {
    newElements.forEach((elem) => {
      delay += 100
      setTimeout(() => {
        productsGrid.appendChild(elem)
        masonry.appended(elem)
        masonry.layout()
      }, delay)
    })

    setTimeout(() => { resolve() }, newElements.length * 110)
  })

  elementsLoaded.then(() => { 
    imageSwitch()
    document.body.classList.remove('loading')
  })
}

function initSummernote() {
  $('.summernote').each(function() {
    $(this).summernote({
      height: 300,
      followingToolbar: false
    })
  })
}